import Heading from "../../components/heading/Heading";
import Image from "../../components/image/Image";
import ListItems from "../List/ListItems";

export function MediaTextRightImage({
  imageSrc,
  imageAlt,
  title,
  text,
  ...rest
}) {
  return (
    <div
      {...rest}
      className="flex flex-col md:flex-row items-center justify-between gap-6 px-6 mt-12"
    >
      {/* Text Section */}
      <div className="w-full md:w-1/2 text-center md:text-left">
        <Heading
          level={3}
          className="text-3xl md:text-4xl font-bold text-white mb-4"
        >
          {title}
        </Heading>
        <p className="text-white text-base md:text-xl font-bold">{text}</p>
      </div>

      {/* Image Section */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
        <Image
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-auto object-cover max-w-md"
        />
      </div>
    </div>
  );
}
